<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { LetterSelectionDraft, LetterSelectionRow } from "../../contract"
  import { destinationAddressLines } from "../../_shared/_logic/recipient"
  let { row, draft }: InboxWorkflowCellProps<LetterSelectionRow, LetterSelectionDraft> = $props()
  const lines = $derived(destinationAddressLines(row, draft))
</script>

<div class="destination-address">
  {#if row.statusLabel === "Datenfehler"}
    —
  {:else if lines.length}
    {#each lines as line}<div>{line}</div>{/each}
  {:else}
    Zieladresse nicht hinterlegt
  {/if}
</div>

<style>
  .destination-address {
    min-width: 12rem;
    max-width: 18rem;
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.4;
    color: var(--text-invers-100);
  }
</style>
